import React from "react";
// JavaScript library for creating fancy carousels like components
import Glide from "@glidejs/glide";
// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

import { Link } from "react-router-dom";

// Core Components
import AmandaImg from "assets/img/amanda.jpeg";
import MaddyImg from "assets/img/maddy.jpeg";
import IreneImg from "assets/img/irene.jpeg";
import JoshImg from "assets/img/test2.jpeg";

function LandingTestimonials() {
  function goToTestimonial() {
    window.location.href = "https://forms.gle/YjRyR85DzTEE31Qe7";
  }
  React.useEffect(() => {
    new Glide(".testimonial-glide", {
      type: "carousel",
      startAt: 0,
      focusAt: 2,
      perTouch: 1,
      perView: 4,
    }).mount();
  }, []);
  return (
    <>
      <div className="testimonials-3">
        <Container fluid>
          <Row>
            <Col className="positioned" lg="3" md="8" xs="10">
              <h3 className="display-3 text-primary">
                65+ Countries. Thousands of users.
              </h3>
              <p className="lead">
                Fighting pandemic surveillance and uniting thousands of people
                everyday. See what our users have to say.
              </p>
              <Button
                className="mt-5 btn btn-secondary"
                style={{ zIndex: 10 }}
                onClick={goToTestimonial}
              >
                Submit Testimonial
              </Button>
            </Col>
            <Col md="12">
              <div className="testimonial-glide">
                <div className="glide__track" data-glide-el="track">
                  <ul className="glide__slides">
                    <li className="glide__slide">
                      <div className="info text-left">
                        <p className="description">
                          "This platform is awesome! The most amazing part is
                          that no installation of any sort is required. HD video
                          quality, clear audio, and easy screen-sharing. Also
                          consumes much less data than any other product. We've
                          tried this on several browsers and it just works
                          everytime."
                        </p>
                        <div className="author">
                          <img
                            alt="..."
                            className="avatar img-raised"
                            src={MaddyImg}
                          ></img>
                          <span>Maddy</span>
                        </div>
                      </div>
                    </li>
                    <li className="glide__slide">
                      <div className="info text-left">
                        <p className="description">
                          "My experience with SecureMeeting has been wonderful.
                          Not only is it very simple to use, but it also has
                          complete functionality for all my needs. Not to
                          mention, it's lack of bulky toolbars and
                          login/accounts make it very aesthetically pleasing.
                          Beautiful product!"
                        </p>
                        <div className="author">
                          <img
                            alt="..."
                            className="avatar img-raised"
                            src={AmandaImg}
                          ></img>
                          <span>Amanda</span>
                        </div>
                      </div>
                    </li>
                    <li className="glide__slide">
                      <div className="info text-left">
                        <p className="description">
                          "This is so insanely simple to use! Love this
                          initiative. You guys are amazing. Your dedication to
                          open source is inspirational. Thank you SecureMeeting
                          for caring! Video quality is crisp, and I love that I
                          can use it on Linux. I use a lot of screensharing for
                          coding and gaming. "
                        </p>
                        <div className="author">
                          <img
                            alt="..."
                            className="avatar img-raised"
                            src={JoshImg}
                          ></img>
                          <span>Josh</span>
                        </div>
                      </div>
                    </li>
                    <li className="glide__slide">
                      <div className="info text-left">
                        <p className="description">
                          "I really like SecureMeeting. I enjoy how prominent
                          the video is, with no lagging, allows you to focus on
                          person you are talking to without distractions, very
                          simple and clean design overall. Great audio quality
                          too! Removes headache of installing apps and setting
                          things up. Great job! "
                        </p>
                        <div className="author">
                          <img
                            alt="..."
                            className="avatar img-raised"
                            src={IreneImg}
                          ></img>
                          <span>Irene</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="glide__arrows" data-glide-el="controls">
                  <button
                    className="glide__arrow glide__arrow--left text-default"
                    data-glide-dir="<"
                  >
                    <i className="ni ni-bold-left"></i>
                  </button>
                  <button
                    className="glide__arrow glide__arrow--right text-default"
                    data-glide-dir=">"
                  >
                    <i className="ni ni-bold-right"></i>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default LandingTestimonials;
